import clsx from 'clsx'
import {useFormik} from 'formik'
import React from 'react'
import {Button, Col, Modal, Row} from 'react-bootstrap'
import * as Yup from 'yup'
import HelpBubble from '../utils/HelpBubble'

const overviewSchema = Yup.object().shape({
  level: Yup.string().required('level field is required'),
  degree: Yup.string()
    .min(150, 'Minimum 150 symbols')
    .max(3, 'Maximum 20 symbols')
    .required('degree field is required'),
  college: Yup.string()
    .min(150, 'Minimum 150 symbols')
    .max(3, 'Maximum 20 symbols')
    .required('college field is required'),
  startDate: Yup.string().required('startDate field is required'),
  endDate: Yup.string().required('endDate field is required'),
})

const initialValues = {
  level: ' ',
  degree: ' ',
  college: '',
  startDate: '',
  endDate: '',
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}
function EducationModal({editModal, handleEditModal}: Props) {
  const formik = useFormik({
    initialValues,
    validationSchema: overviewSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Add your Education information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} noValidate>
          <HelpBubble
            icon='/media/icons/duotune/general/gen045.svg'
            text='Please make sure that this information is accurate as it will be verfied with a
                goverment issued identification later on'
          />

          <div>
            <Row>
              <Col md={12} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>Level of education</label>

                  <select
                    className='form-select form-select-solid form-select-lg fw-bold'
                    {...formik.getFieldProps('level')}
                  >
                    <option value=''>Select level...</option>
                    <option value='AF'>Bachelors</option>
                    <option value='AX'>Doctrate</option>
                    <option value='AL'>MBA</option>
                    <option value='DZ'>Masters</option>
                    <option value='AS'>Secondary/ Highshcool</option>
                    <option value='AS'>Other</option>
                  </select>
                  {formik.touched.level && formik.errors.level && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.level}</div>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold  '>Degree:</label>

                  <input
                    {...formik.getFieldProps('degree')}
                    placeholder='Degree'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.degree && formik.errors.degree},
                      {
                        'is-valid': formik.touched.degree && !formik.errors.degree,
                      }
                    )}
                    type='text'
                    name='degree'
                    autoComplete='off'
                  />
                  {formik.touched.degree && formik.errors.degree && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.degree}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold  '>College:</label>

                  <input
                    {...formik.getFieldProps('college')}
                    placeholder='College'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.college && formik.errors.college},
                      {
                        'is-valid': formik.touched.college && !formik.errors.college,
                      }
                    )}
                    type='text'
                    name='college'
                    autoComplete='off'
                  />
                  {formik.touched.college && formik.errors.college && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.college}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>Start Date:</label>

                  <input
                    {...formik.getFieldProps('startDate')}
                    placeholder=''
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.startDate && formik.errors.startDate},
                      {
                        'is-valid': formik.touched.startDate && !formik.errors.startDate,
                      }
                    )}
                    type='text'
                    name='startDate'
                    autoComplete='off'
                  />
                  {formik.touched.startDate && formik.errors.startDate && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.startDate}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>End Date:</label>

                  <input
                    {...formik.getFieldProps('endDate')}
                    placeholder=''
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.endDate && formik.errors.endDate},
                      {
                        'is-valid': formik.touched.endDate && !formik.errors.endDate,
                      }
                    )}
                    type='text'
                    name='endDate'
                    autoComplete='off'
                  />
                  {formik.touched.endDate && formik.errors.endDate && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.endDate}</span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button type='submit' disabled={formik.isSubmitting || !formik.isValid} variant='primary'>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EducationModal
